import { createModel } from '@/store/tools';
import { isPlat, isOC } from '@/assets/js/authType';
const model = {
    namespace: 'deliveryeval',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getlistAppraiseInfo': T('getlistAppraiseInfo'), // 骑手评价--列表
            'getappraiseInfoDetail': T('getappraiseInfoDetail'), // 骑手评价--详情
            'getfindStars': T('getfindStars'), // 星级
        },
        actions: {
             'getlistAppraiseInfo': A('getlistAppraiseInfo'), // 骑手评价--列表
             'getappraiseInfoDetail': A('getappraiseInfoDetail'), // 骑手评价--详情
             'getfindStars': A('getfindStars'), // 骑手评价--星级
        },
        sagas: {
            'getlistAppraiseInfo': S('getlistAppraiseInfo', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderAppraiseService.listAppraiseInfo'),
            'getappraiseInfoDetail': S('getappraiseInfoDetail', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderAppraiseService.appraiseInfoDetail'),
            'getfindStars': S('getfindStars', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderAppraiseService.findStars'),
        },
        reducers: {
            'listAppraiseInfo': R('getlistAppraiseInfo', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'appraiseInfoDetail': R('getappraiseInfoDetail', {}),
            'findStars': R('getfindStars', []),
        }
    })
};
export default createModel(model);